import { apiClient } from './client'
import type { CatalogItemSource, CatalogSource, CreateCatalogItemSourceRequest } from './types'

/** Phase 16 — list registered + enabled sources for the Add Source picker. */
export const listCatalogSources = async (): Promise<CatalogSource[]> => {
  const response = await apiClient.get<CatalogSource[]>('/api/v1/catalog-sources')
  return response.data
}

/** Phase 16 — list every source binding for one global catalog row. */
export const listItemSources = async (
  kind: 'MATERIAL' | 'TOOL',
  globalId: string
): Promise<CatalogItemSource[]> => {
  const response = await apiClient.get<CatalogItemSource[]>('/api/v1/catalog-item-sources', {
    params: { kind, globalId },
  })
  return response.data
}

/**
 * Phase 16 — bind a global row to a source. 409 surfaces a duplicate; 400 surfaces an invalid URL
 * (SSRF guard) or unknown global row. Callers should let AxiosError bubble for the dialog to
 * display.
 */
export const createItemSource = async (
  request: CreateCatalogItemSourceRequest
): Promise<CatalogItemSource> => {
  const response = await apiClient.post<CatalogItemSource>('/api/v1/catalog-item-sources', request)
  return response.data
}

/** Phase 16 — refresh a single binding's live price; returns the updated row. */
export const refreshItemSource = async (id: string): Promise<CatalogItemSource> => {
  const response = await apiClient.post<CatalogItemSource>(
    `/api/v1/catalog-item-sources/${id}/refresh`
  )
  return response.data
}

export const deleteItemSource = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/v1/catalog-item-sources/${id}`)
}
